module.exports = __webpack_public_path__ + "img/bubble_red_3.afcf3dd5.png";